import { render, staticRenderFns } from "./AssetsCollection.vue?vue&type=template&id=73329f76&scoped=true"
import script from "./AssetsCollection.vue?vue&type=script&lang=js"
export * from "./AssetsCollection.vue?vue&type=script&lang=js"
import style0 from "./AssetsCollection.vue?vue&type=style&index=0&id=73329f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73329f76",
  null
  
)

export default component.exports